import React from 'react';
import { CheckCircle } from 'lucide-react';
const PURCHASE_URL = 'https://digitalespro.com/cart/47867900788950:1';
export function PricingSection() {
  return <section id="compra" className="bg-[#1a1a2e] py-10 md:py-16 px-4 text-white relative overflow-hidden scroll-mt-4" data-id="element-100">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-101">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-102"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-103"></div>
      </div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-104">
        <div className="text-center mb-8" data-id="element-105">
          <div className="inline-block bg-red-600 text-white font-bold px-4 py-1 rounded animate-bounce mb-3 text-sm" data-id="element-106">
            ⏰ Oferta por tiempo limitado
          </div>
          <h2 className="text-3xl md:text-4xl font-black mb-4 font-['Oswald'] uppercase" data-id="element-107">
            Accedé al Pack Completo <br data-id="element-108" />
            <span className="text-yellow-400" data-id="element-109">+ los 3 Bonos de regalo</span>
          </h2>
        </div>

        <div className="bg-white text-gray-900 rounded-2xl shadow-2xl overflow-hidden max-w-lg mx-auto border-4 border-green-400" data-id="element-110">
          <div className="bg-gray-100 p-4 border-b border-gray-200 text-center" data-id="element-111">
            <h3 className="text-lg font-bold text-gray-600 uppercase tracking-wide" data-id="element-112">
              📦 Lo que vas a recibir hoy:
            </h3>
          </div>

          <div className="p-6 md:p-8" data-id="element-113">
            <ul className="space-y-3 mb-6" data-id="element-114">
              <li className="flex items-center gap-3 text-base font-bold" data-id="element-115">
                <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-116" />
                <span data-id="element-117">6 Tomos completos del cuerpo humano</span>
              </li>
              <li className="flex items-center gap-3 text-base" data-id="element-118">
                <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-119" />
                <span data-id="element-120">Bono #1: Sistema de Evaluación</span>
              </li>
              <li className="flex items-center gap-3 text-base" data-id="element-121">
                <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-122" />
                <span data-id="element-123">Bono #2: MegaPack Juegos Didácticos</span>
              </li>
              <li className="flex items-center gap-3 text-base" data-id="element-124">
                <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-125" />
                <span data-id="element-126">Bono #3: Planificador Estratégico</span>
              </li>
            </ul>

            <div className="grid grid-cols-3 gap-1 text-center text-xs text-gray-500 mb-6 border-t border-b border-gray-100 py-3" data-id="element-127">
              <div data-id="element-128">Material descargable</div>
              <div className="border-l border-r border-gray-100" data-id="element-129">
                Acceso inmediato
              </div>
              <div data-id="element-130">Organización profesional</div>
            </div>

            <div className="text-center mb-6" data-id="element-131">
              <p className="text-gray-400 line-through text-lg mb-1" data-id="element-132">
                Valor total real: $ 49990
              </p>
              <div className="flex items-center justify-center gap-2" data-id="element-133">
                <span className="text-xl font-bold text-gray-700" data-id="element-134">
                  HOY SOLO:
                </span>
                <span className="text-4xl md:text-5xl font-black text-[#22c55e]" data-id="element-135">
                  $ 19990
                </span>
              </div>
            </div>

            <a href={PURCHASE_URL} target="_blank" rel="noopener noreferrer" className="w-full bg-[#22c55e] hover:bg-[#16a34a] text-white text-lg md:text-xl font-black py-4 px-4 rounded-lg shadow-[0_4px_0_#15803d] active:shadow-[0_2px_0_#15803d] active:translate-y-1 transition-all uppercase flex items-center justify-center gap-2 animate-pulse mb-4 no-underline" data-id="element-136">
              👉 Obtener mi pack completo hoy
            </a>

            <div className="flex justify-center gap-3 md:gap-6 text-xs text-gray-500 font-medium flex-wrap" data-id="element-137">
              <span className="flex items-center gap-1" data-id="element-138">
                <CheckCircle className="w-3.5 h-3.5" data-id="element-139" /> Un solo pago
              </span>
              <span className="flex items-center gap-1" data-id="element-140">
                <CheckCircle className="w-3.5 h-3.5" data-id="element-141" /> Descarga digital
              </span>
              <span className="flex items-center gap-1" data-id="element-142">
                <CheckCircle className="w-3.5 h-3.5" data-id="element-143" /> Acceso de por vida
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}